import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
import facebookIcon from '../../img/facebook-icon.svg';
import twitterIcon from '../../img/twitter-icon.svg';
import linkedinIcon from '../../img/linkedin-icon.svg';
import youtubeIcon from '../../img/youtube-icon.svg';
var SocialList = styled.ul.withConfig({
  displayName: "SocialIcons__SocialList",
  componentId: "uszhsw-0"
})(["margin:0;list-style-type:none;"]);
var SocialListItem = styled.li.withConfig({
  displayName: "SocialIcons__SocialListItem",
  componentId: "uszhsw-1"
})(["display:inline-block;margin-bottom:0;margin-right:", "px;&:last-child{margin-right:0;}"], spacing.base * 2);
var ImageStyled = styled.img.withConfig({
  displayName: "SocialIcons__ImageStyled",
  componentId: "uszhsw-2"
})(["height:", "px;margin-bottom:0;"], spacing.base);

var SocialIcons = function SocialIcons(_ref) {
  var Link = _ref.Link;
  return React.createElement(SocialList, null, React.createElement(SocialListItem, null, React.createElement(Link, {
    href: "https://www.youtube.com/user/papertrailio/videos",
    target: "_blank"
  }, React.createElement(ImageStyled, {
    src: youtubeIcon,
    alt: "YouTube icon"
  }))), React.createElement(SocialListItem, null, React.createElement(Link, {
    href: "https://www.facebook.com/papertrail.io/",
    target: "_blank"
  }, React.createElement(ImageStyled, {
    src: facebookIcon,
    alt: "Facebook icon"
  }))), React.createElement(SocialListItem, null, React.createElement(Link, {
    href: "https://twitter.com/papertrail_io",
    target: "_blank"
  }, React.createElement(ImageStyled, {
    src: twitterIcon,
    alt: "Twitter icon"
  }))), React.createElement(SocialListItem, null, React.createElement(Link, {
    href: "https://www.linkedin.com/company/kit-log",
    target: "_blank"
  }, React.createElement(ImageStyled, {
    src: linkedinIcon,
    alt: "LinkedIn icon"
  }))));
};

export default SocialIcons;